import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareIssuetypesWorkflowRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-software-routes/src/projectSettingsSoftwareIssuetypesWorkflowRoute.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { softwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { workflowBuilderProvisioningResource } from '@atlassian/jira-router-resources-admin-pages-workflow-builder-provisioning/src/index.tsx';
import { projectWorkflowContextResource } from '@atlassian/jira-router-resources-project-workflow-context/src/services/project-workflow-context/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { workflowCapabilitiesResource } from '@atlassian/jira-router-resources-admin-pages-workflow-capabilities/src/index.tsx';
import { workflowDocumentResource } from '@atlassian/jira-router-resources-admin-pages-workflow-document/src/index.tsx';
import { LazyIssueTypeSettings } from './ui/project-settings/issue-type/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import WorkflowNavigationPage, {
	LazyWorkflowNavigationSettings,
} from './ui/project-settings/workflow-navigation/index.tsx';

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const projectSettingsSoftwareIssuetypesWorkflowRouteEntry = createEntry(
	projectSettingsSoftwareIssuetypesWorkflowRoute,
	() => ({
		group: 'project-settings-software',
		component: WorkflowNavigationPage,

		layout: expValEquals('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false)
			? chromelessLayout
			: softwareProjectLayout,

		navigation: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_software',
			'isEnabled',
			true,
			false,
		)
			? undefined
			: {
					horizontal: GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV,
					menuId: MENU_ID.PROJECTS,
					sidebar: AsyncSidebarNextGen,
					sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
				},

		resources: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_software',
			'isEnabled',
			true,
			false,
		)
			? [
					...jiraSpaResources(),
					// Delete this resource after hix-7127_wfe_layout_to_chromeless_for_software experiment is over
					projectContextResource,
					projectWorkflowContextResource,
					workflowCapabilitiesResource,
					workflowDocumentResource,
					rovoEntitlementResource,
					...getWorkflowBuilderProvisioningResources(),
				]
			: [
					...jiraSpaResources(),
					...getSettingsNavigationResources(),
					...getWorkflowBuilderProvisioningResources(),
					workflowBuilderProvisioningResource,
				],

		forPaint: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_software',
			'isEnabled',
			true,
			false,
		)
			? [LazyWorkflowNavigationSettings]
			: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareIssuetypesWorkflowRouteEntry.tsx',
				whichExportToUse: 'projectSettingsSoftwareIssuetypesWorkflowRouteEntry',
			},

			enabled: true,
		},
	}),
);
